module.exports = __webpack_public_path__ + "media/images/lb/174-91011db1b10168a7419e3f4ec3eb974c.svg";